import React from 'react';

type Props = {
  badgeName: string;
  storeIdentifierName: string;
};

const Badge = ({ badgeName, storeIdentifierName }: Props) => {
  return (
    <div className="quickview-badge-container" data-testid="quickViewModalbadgeName">
      {badgeName && (
        <img
          src={`https://images.dickssportinggoods.com/assets/badges/${storeIdentifierName}/plp/PLP-${badgeName}.svg`}
          alt={badgeName}
        />
      )}
    </div>
  );
};

export default Badge;
